import React from 'react';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';

import FormRecurringMeetingsSelection from 'Shared/components/FormComponents/FormRecurringMeetingsSelection';
import { WorkspaceType } from 'Shared/constants/types';

import ManualWorkspaceField from './ManualWorkspaceField/ManualWorkspaceField';
import AddOrUpdateWorkspaceForm from './AddOrUpdateWorkspaceForm/AddOrUpdateWorkspaceForm';

function FormFields() {
  return (
    <div className="OneOnOneWorkspacesFromCalendar">
      <div className="my-3">
        <FormRecurringMeetingsSelection selector="recurringMeetings" type={WorkspaceType.isTeammate} mobileVersion />
      </div>
      <FieldArray name="workspaces">
        {({ fields }) => (
          <>
            {fields.value?.filter(({ recurring_meeting_uuid }) => !recurring_meeting_uuid)?.length > 0 && (
              <div className="OneOnOneWorkspacesFromCalendar__label mt-4 mb-2">Manually Created workspaces</div>
            )}
            {fields.map((name, index) => {
              const workspace = fields.value[index];
              if (workspace.recurring_meeting_uuid) return null;
              return <Field key={workspace?.uuid} name={name} index={index} component={ManualWorkspaceField} />;
            })}
          </>
        )}
      </FieldArray>
      <Field name="addOrUpdateWorkspaceFormOpen" component={AddOrUpdateWorkspaceForm} />
    </div>
  );
}

export default FormFields;
